<div class="grid">
    <div class="col-12 md:col-6">
        <div class="card p-fluid">
			<h5>Email</h5>
			<div class="field">
				<label htmlFor="name1">To</label>
				<!--input pInputText id="name1" type="text" /-->
                <p-chips [(ngModel)]="toEmails" separator=","></p-chips>
			</div>
			<div class="field">
				<label htmlFor="email1">Subject</label>
				<input pInputText id="email1" type="text" />
			</div>
			

		</div>
    </div>
    <div class="col-6 md:col-3">
        <div >
			<button pButton pRipple type="button" label="Enviar" class="p-button-rounded p-button-success"></button>
			

		</div>
    </div>

</div>


<p-editor #editor [(ngModel)]="text" [style]="{'height':'320px'}"></p-editor>

<!--textarea [(ngModel)]="text" rows="100" cols="100" pInputTextarea autoResize="autoResize"></textarea-->